export default __webpack_public_path__ + "static/media/workProcessAnalysis.e7405d2c.jpg";